import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';

export const BaseCellEntry = styled.span`
  display: grid;
  column-gap: 6px;
  grid-template-columns: max-content 1fr;

  @media all and (max-width: ${layout.sm}) {
    svg {
      width: 20px;
    }
  }
`;

export const IconOnly = styled(BaseCellEntry)`
  grid-template-columns: min-content;
  justify-self: center;
  align-self: center;
`;

export const TextOnly = styled(BaseCellEntry)`
  grid-template-columns: unset;
  justify-self: center;
  align-self: center;

  > p {
    text-align: center;
  }
`;
